import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { toast } from '@sales-center/components'
import { getSalesTeamPositionsData } from '../api'

export const useGetSalesTeamPositionsData = () => {
  const dispatch = useAppDispatch()
  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getSalesTeamPositionsData())

        if (mounted) {
          if (getSalesTeamPositionsData.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
            toast.error(
              `Error loading salesTeam positions data: ${result.payload}`,
            )
          }
        }
      } catch (error) {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
